import ReactDOM from 'react-dom/client'
import "./styles/tailwind.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import React from 'react';
import { Home, Detail, Shop, Info, List, Game, Help, HelpDetail } from './pages'
import 'spinkit/spinkit.min.css'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "detail/:id",
    element: <Detail />,
  },
  {
    path: "shop/:id",
    element: <Shop />,
  },
  {
    path: "info/:id",
    element: <Info />,
  },
  {
    path: "list",
    element: <List />,
  },
  {
    path: "game",
    element: <Game />,
  },
  {
    path: "help",
    element: <Help />,
  },
  {
    path: "helpdetail/:id",
    element: <HelpDetail />,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
